var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ff601f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241,15.5v31c0,8.3,6.7,15,15,15s15-6.7,15-15V15.5c0-8.3-6.7-15-15-15s-15,6.7-15,15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,256.5c0-8.3-6.7-15-15-15H15c-8.3,0-15,6.7-15,15s6.7,15,15,15h31c8.3,0,15-6.7,15-15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497,241.5h-31c-8.3,0-15,6.7-15,15s6.7,15,15,15h31c8.3,0,15-6.7,15-15s-6.7-15-15-15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.6,348.5l-26,15c-7.2,4.1-9.6,13.3-5.5,20.5,4.2,7.2,13.4,9.6,20.5,5.5l26-15c7.2-4.1,9.6-13.3,5.5-20.5-4.2-7.2-13.3-9.6-20.5-5.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445.4,164.5l26-15c7.2-4.1,9.6-13.3,5.5-20.5s-13.4-9.7-20.5-5.5l-26,15c-7.2,4.1-9.6,13.3-5.5,20.5,4.2,7.2,13.4,9.6,20.5,5.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363,41.2l-15,26c-4.1,7.2-1.7,16.3,5.5,20.5,7.1,4.1,16.3,1.7,20.5-5.5l15-26c4.1-7.2,1.7-16.3-5.5-20.5s-16.3-1.7-20.5,5.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.5,35.7c-7.2,4.1-9.6,13.3-5.5,20.5l15,26c4.2,7.2,13.4,9.6,20.5,5.5,7.2-4.1,9.6-13.3,5.5-20.5l-15-26c-4.2-7.2-13.4-9.6-20.5-5.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.3,363.5l-26-15c-7.2-4.1-16.3-1.7-20.5,5.5s-1.7,16.3,5.5,20.5l26,15c7.1,4.1,16.3,1.7,20.5-5.5,4.1-7.2,1.7-16.3-5.5-20.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.6,138.5l-26-15c-7.2-4.2-16.3-1.7-20.5,5.5s-1.7,16.3,5.5,20.5l26,15c7.1,4.1,16.3,1.7,20.5-5.5,4.1-7.2,1.7-16.3-5.5-20.5Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,121.9c-67.4,0-117.3,45.4-130.9,100.9-11.6,47.3,1.9,95.6,36.1,129.2,10.2,10,16.6,24,18.8,39.5h152.1c2.3-15.4,9-29.8,19.7-40.4,25.3-25.4,39.2-59,39.2-94.6,0-72.6-57.3-134.6-135-134.6ZM256,361.5c-8.3,0-15-6.7-15-15s6.7-15,15-15,15,6.7,15,15-6.7,15-15,15ZM272.6,283.3l-1.6,3.2c0,8.3-6.7,15-15,15s-15-6.7-15-15c0-14.2,8.1-26.1,20.5-31.1,5.8-2.3,9.5-7.8,9.5-13.9s-6.7-15-15-15-15,6.7-15,15-6.7,15-15,15-15-6.7-15-15c0-24.8,20.2-45,45-45s45,20.2,45,45-11.1,35-28.4,41.8Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181,432.1c0,44.5,32.9,79.4,75,79.4s75-33.6,75-75v-15h-150v10.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.90d3099e4a2e08f060fd3cc5499c7c77.svg";
export { ForwardRef as ReactComponent };